import React from 'react'
import PropTypes from 'prop-types'

import { Segment, Item } from 'semantic-ui-react'

import { db } from '../../firebase';

import PhoneItem from './PhoneItem'

class PhoneList extends React.Component {

  getPhoneLocations = (number, e) => {
    db.onceGetPhoneLocations(number)
      .then(snapshot => {
        this.props.onLocationsFound(snapshot.val(), number)
      })
      .catch(error => {
        console.log(error);
      });
  }

  render() {
    const { phones, number } = this.props
    return(

          phones ? (
            <Segment>
              <h4>Phone Numbers Tracked</h4>
              <Item.Group divided>
              { Object.keys(phones).map(key => {
                return (
                    <PhoneItem
                      key={key}
                      phone={key}
                      selected={key == number}
                      onClick={(e) => this.getPhoneLocations(key, e)}
                     />
                )
              })}
              </Item.Group>
            </Segment>
          )
        : null
    )
  }

  static propTypes = {
    phones: PropTypes.object.isRequired,
    number: PropTypes.string.isRequired,
    onLocationsFound: PropTypes.func.isRequired,
  }
}

export default PhoneList



// WEBPACK FOOTER //
// ./src/components/Phone/PhoneList.js